import ViewModeSelector from "./ViewModeSelector"

export default function ViewSelector({
  availableViews,
  currentViewMode,
  defaultView,
  rootUrl,
}) {
  const urlForView = (key) =>
    key === defaultView ? rootUrl : `${rootUrl}/${key}`

  const viewModes = [
    {
      url: urlForView("table"),
      key: "table",
      title: "Table View",
      icon: "bars-4",
    },
    {
      url: urlForView("map"),
      key: "map",
      title: "Map View",
      icon: "globe-alt",
      className: "hidden sm:flex",
    },
    {
      url: urlForView("split"),
      key: "split",
      title: "Split View",
      icon: "square-2-stack",
      className: "hidden sm:flex",
    },
    {
      url: urlForView("cards"),
      key: "cards",
      title: "Card View",
      icon: "squares-2x2",
    },
    {
      url: urlForView("compare"),
      key: "compare",
      title: "Compare View",
      icon: "view-columns",
      className: "hidden sm:flex",
    },
    {
      url: urlForView("overview"),
      key: "overview",
      title: "Overview",
      icon: "presentation-chart-line",
      className: "hidden sm:flex",
    },
  ].filter(({ key }) => availableViews.includes(key))

  if (viewModes.length > 1) {
    return (
      <ViewModeSelector
        viewModes={viewModes}
        currentViewMode={currentViewMode}
      />
    )
  } else {
    return null
  }
}
